import { useState } from "react";
import { API_URL } from "../config/environment";
import { useTranslation } from 'react-i18next';
import axios from "axios";
/**
 * This is the first stage of password resetting, where the user specifies their email so that
 * a unique password reset URL is sent to their email address. 
 * This hook calls the Reset Password API in Djoser
 * see more here https://djoser.readthedocs.io/en/latest/base_endpoints.html#reset-password
 * @returns hook's state variables, modifiels and resetPassword handler
 */

export default function useResetPassword() {
  const {
    t
  } = useTranslation();
  const [email, setEmail] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [successful, setSuccessful] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleResetPassword = () => {
    setLoading(true);
    setError(false);
    setSuccessful(false);
    var config = {
      method: 'post',
      url: `${API_URL}/api/users/reset_password/`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        "email": email
      }
    };
    axios(config).then(function (response) {
      setSuccessful(true); // TODO: Translate message

      setSuccessMessage("The email was successfully sent! Please check your email address");
    }).catch(function (error) {
      setLoading(false);
      setError(true); // TODO: Translate message

      setErrorMessage("User with given email does not exist.");
    });
  };

  return {
    email,
    setEmail,
    successMessage,
    setSuccessMessage,
    successful,
    setSuccessful,
    error,
    setError,
    errorMessage,
    setErrorMessage,
    loading,
    setLoading,
    handleResetPassword
  };
}